// import React, { Component } from "react";
// import axios from "axios";
// import Sidebar from './SidebarScanner';
// import Navbar from './Navbar';
// import logo from "../Assets/images/avatar1.png";
// import LoaderRounded from './LoaderRounded';
// import { Modal, Button } from "react-bootstrap";

// export default class newscanbymobileno extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             mobile: '',
//             event_amount: 999,
//             payment_type: 'OFFLINE',
//             memberData: '',
//             disabledd: false,
//             isloader: false,
//             errors: {},
//             eventiddata: JSON.parse(localStorage.getItem('operatorrrr')),
//             member: null,
//             showPopup: false,
//             selectedBenefits: [],
//             subscriptionData: null,
//         };
//     }

//     handleFormChange = (event) => {
//         this.setState({
//             [event.target.name]: event.target.value
//         });
//     }

//     getMemberListbyMobileNumber = async (mobile) => {
//         const response = await axios.post(
//             process.env.REACT_APP_TALK_API + `/eventTeam/getUserDetails`,
//             { mobile }
//         );
//         if (response.data.Status === 200) {
//             let members = {
//                 member: {
//                     ...response.data.data,
//                     designation: "member",
//                     is_attended: false,
//                     is_cancelled: false,
//                     is_registered: true,
//                     is_payment_done: true
//                 }
//             };
//             this.setState(
//                 {
//                     member: response.data.data,
//                     memberData: members
//                 },
//                 () => {
//                     this.getSubscriptionDetails();
//                 }
//             );

//         } else {
//             alert('Record not found');
//         }
//     };

//     getSubscriptionDetails = async () => {
//         const payload = {
//             yin_id: this.state.member?.yin_id || "",
//             mobile: "",
//         };

//         try {
//             const response = await axios.post(
//                 process.env.REACT_APP_APIURL + `/subscription/read`,
//                 payload
//             );
//             if (Array.isArray(response.data.data) && response.data.data.length > 0) {
//                 this.setState({ subscriptionData: response.data.data[0] });
//             }
//         } catch (error) {
//             console.error("Error fetching subscription details:", error);
//         }
//     };

//     submitRewards = async () => {
//         const data = {
//             yinId: this.state.member?.yin_id,
//             rewardType: this.state.selectedBenefits.map(item => item.toLowerCase()),
//         };

//         try {
//             this.setState({ isloader: true });

//             const response = await axios.post(
//                 process.env.REACT_APP_APIURL + `/qrsub/scanQRCode`,
//                 data,
//                 {
//                     validateStatus: (status) => {
//                         return status === 200 || status === 606;
//                     },
//                 }
//             );

//             if (response.status === 200) {
//                 alert("Reward submitted successfully!");
//                 window.location.href = '/list/scanner';
//             } else if (response.status === 606) {
//                 alert(response.data.message);
//             } else {
//                 alert(response.Message);
//             }

//         } catch (error) {
//             console.error("Error while submitting reward:", error);
//             alert("Failed to submit reward");
//         } finally {
//             this.setState({ isloader: false, selectedBenefits: [] });
//         }
//     };

//     handleBenefitChange = (e) => {
//         let { selectedBenefits } = this.state;
//         if (e.target.checked) {
//             selectedBenefits.push(e.target.value);
//         } else {
//             selectedBenefits = selectedBenefits.filter(item => item !== e.target.value);
//         }
//         this.setState({ selectedBenefits });
//     }

//     render() {
//         const { subscriptionData } = this.state;

//         return (
//             <>
//                 <Sidebar />
//                 <div className="main">
//                     <div className="topbar">
//                         <Navbar />
//                     </div>

//                     <div className="container">
//                         <div className="row mt-4">
//                             <div className="col-lg-8 col-md-8 col-12 paddingAll10 mx-auto ">
//                                 <div className="card rounded shadow shadow-sm">
//                                     <div className="card-header">
//                                         <h3 className="mb-0 center">Scan By Mobile Number</h3>
//                                     </div>
//                                     <div className="card-body">
//                                         <div className="form-group">
//                                             <label htmlFor="mobile" className="control-label">Mobile Number</label>
//                                             <input
//                                                 type="text"
//                                                 name="mobile"
//                                                 value={this.state.mobile}
//                                                 onChange={this.handleFormChange}
//                                                 className="form-control"
//                                                 placeholder="Type here"
//                                             />
//                                             <div className="errorMsg">{this.state.errors.mobile}</div>
//                                         </div>
//                                         <div className="form-group">
//                                             <button
//                                                 onClick={() => this.getMemberListbyMobileNumber(this.state.mobile)}
//                                                 className="btn btn-primary btn-lg btn-block"
//                                                 style={{ marginLeft: "300px" }}
//                                             >
//                                                 Submit
//                                             </button>
//                                         </div>
//                                         <br />
//                                         {this.state.member && (
//                                             <div>
//                                                 <div className="row mt-2">
//                                                     <div className="col">
//                                                         <div className="card rounded shadow shadow-sm">
//                                                             <div className="card">
//                                                                 <h3 className="card-title mb-0 text-center"><b>Profile</b></h3>
//                                                                 <div className="row align-items-center" style={{ marginTop: "10px", marginBottom: "10px" }}>
//                                                                     <div className="img col d-flex justify-content-center">
//                                                                         {this.state.member.profile_image[0] ? (
//                                                                             <img src={this.state.member.profile_image[0]} alt="imhe" width="250px" height="140px" />
//                                                                         ) : (
//                                                                             <img src={logo} alt="image_logo" />
//                                                                         )}
//                                                                     </div>
//                                                                 </div>
//                                                                 <br />
//                                                                 <div className="card-header1  text-center">
//                                                                     <div>
//                                                                         <label><h5><b>{this.state.member.first_name}&nbsp;{this.state.member.last_name}</b></h5></label><br />
//                                                                         <label>College Name: {this.state.member.college_name}</label><br />
//                                                                         <label>Mobile: {this.state.member.mobile}</label><br />
//                                                                         <label>YIN ID: {this.state.member.yin_id}</label><br />
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <br />

//                                                 {/* Submit Button -> Modal open */}
//                                                 <div className="form-group text-center mt-4">
//                                                     {subscriptionData?.claimedRewards &&
//                                                         Object.values(subscriptionData.claimedRewards).every(val => val === true) ? (
//                                                         <div className="alert alert-success fw-bold" role="alert" style={{ fontSize: "18px" }}>
//                                                             🎉 You have received all your goodies!
//                                                         </div>
//                                                     ) : (
//                                                         <button
//                                                             type="button"
//                                                             className="btn btn-primary btn-lg"
//                                                             onClick={() => {
//                                                                 this.setState({ showPopup: true });
//                                                             }}
//                                                             disabled={this.state.disabledd}
//                                                         >
//                                                             {this.state.isloader ? <LoaderRounded /> : "Submit"}
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Popup Modal */}
//                 <Modal show={this.state.showPopup} onHide={() => this.setState({ showPopup: false })} centered>
//                     <Modal.Header closeButton>
//                         <Modal.Title>Please select membership benefits</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <div className="row">
//                             {/* Bag */}
//                             <div className="col d-flex align-items-center">
//                                 {subscriptionData?.claimedRewards?.bag ? (
//                                     <span style={{ color: "green", fontWeight: "600" }}>
//                                         ✅ Bag
//                                     </span>
//                                 ) : (
//                                     <>
//                                         <input
//                                             type="checkbox"
//                                             className="form-check-input me-2"
//                                             value="Bag"
//                                             id="bagCheck"
//                                             onChange={this.handleBenefitChange}
//                                             style={{ border: "1px solid #000", width: "18px", height: "18px" }}
//                                         />
//                                         <label className="form-check-label mt-2" htmlFor="bagCheck">
//                                             Bag
//                                         </label>
//                                     </>
//                                 )}
//                             </div>

//                             {/* Bottle */}
//                             <div className="col d-flex align-items-center">
//                                 {subscriptionData?.claimedRewards?.bottle ? (
//                                     <span style={{ color: "green", fontWeight: "600" }}>
//                                         ✅ Bottle
//                                     </span>
//                                 ) : (
//                                     <>
//                                         <input
//                                             type="checkbox"
//                                             className="form-check-input me-2"
//                                             value="Bottle"
//                                             id="bottleCheck"
//                                             onChange={this.handleBenefitChange}
//                                             style={{ border: "1px solid #000", width: "18px", height: "18px" }}
//                                         />
//                                         <label className="form-check-label mt-2" htmlFor="bottleCheck">
//                                             Bottle
//                                         </label>
//                                     </>
//                                 )}
//                             </div>

//                             {/* Kit */}
//                             <div className="col d-flex align-items-center">
//                                 {subscriptionData?.claimedRewards?.kit ? (
//                                     <span style={{ color: "green", fontWeight: "600" }}>
//                                         ✅ Kit
//                                     </span>
//                                 ) : (
//                                     <>
//                                         <input
//                                             type="checkbox"
//                                             className="form-check-input me-2"
//                                             value="Kit"
//                                             id="kitCheck"
//                                             onChange={this.handleBenefitChange}
//                                             style={{ border: "1px solid #000", width: "18px", height: "18px" }}
//                                         />
//                                         <label className="form-check-label mt-2" htmlFor="kitCheck">
//                                             Kit
//                                         </label>
//                                     </>
//                                 )}
//                             </div>

//                         </div>
//                     </Modal.Body>
//                     <Modal.Footer>
//                         <Button
//                             variant="secondary"
//                             onClick={() => this.setState({ showPopup: false })}
//                         >
//                             Cancel
//                         </Button>
//                         <Button
//                             variant="primary"
//                             disabled={this.state.selectedBenefits.length === 0} // disabled until checkbox select
//                             onClick={() => {
//                                 this.setState({ showPopup: false }, () => {
//                                     this.submitRewards();
//                                 });
//                             }}
//                         >
//                             Save
//                         </Button>
//                     </Modal.Footer>
//                 </Modal>
//             </>
//         );
//     }
// }



import React, { Component } from "react";
import axios from "axios";
// import Sidebar from './SidebarScanner';
import Sidebar from "./Sidebar"
import Navbar from './Navbar';
import logo from "../Assets/images/avatar1.png";
import LoaderRounded from './LoaderRounded';
import { Modal, Button } from "react-bootstrap";

export default class newscanbymobileno extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobile: '',
            event_amount: 999,
            payment_type: 'OFFLINE',
            memberData: '',
            disabledd: false,
            isloader: false,
            errors: {},
            eventiddata: JSON.parse(localStorage.getItem('operatorrrr')),
            member: null,
            showPopup: false,
            selectedBenefits: [],
            subscriptionData: null,
        };
    }

    // for mobile number validation and only number allow
    handleFormChange = (event) => {
        const { name, value } = event.target;

        const onlyNumbers = value.replace(/\D/g, '');

        this.setState(
            {
                [name]: onlyNumbers,
                errors: { ...this.state.errors, mobile: "" },
            },
            () => {
                if (name === "mobile" && onlyNumbers.trim().length < 10) {
                    this.setState({ member: null, memberData: null, disabledd: false });
                }
            }
        );
    };


    getMemberListbyMobileNumber = async (mobile) => {
        if (!mobile) {
            alert("Mobile number is required");
            return;
        } else if (mobile.length < 10) {
            alert("Please enter a valid 10-digit mobile number");
            return;
        }

        try {
            const response = await axios.post(
                process.env.REACT_APP_TALK_API + `/eventTeam/getUserDetails`,
                { mobile }
            );

            if (response.data.Status === 200) {
                let members = {
                    member: {
                        ...response.data.data,
                        designation: "member",
                        is_attended: false,
                        is_cancelled: false,
                        is_registered: true,
                        is_payment_done: true
                    }
                };
                this.setState(
                    {
                        member: response.data.data,
                        memberData: members,
                        disabledd: true
                    },
                    () => {
                        this.getSubscriptionDetails();
                    }
                );
            } else {
                alert('Record not found');
                this.setState({ member: null, memberData: null, disabledd: false });
            }
        } catch (error) {
            console.error(error);
            alert("Error fetching member details");
        }
    };

    // for subscription data
    getSubscriptionDetails = async () => {
        const payload = {
            yin_id: this.state.member?.yin_id || "",
            mobile: "",
            isSubscription: true
        };

        try {
            const response = await axios.post(
                process.env.REACT_APP_APIURL + `/subscription/read`,
                payload
            );
            if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                this.setState({ subscriptionData: response.data.data[0] });
            }
        } catch (error) {
            console.error("Error fetching subscription details:", error);
        }
    };

    // for submit reward
    submitRewards = async () => {
        if (!this.state.mobile) {
            alert("Mobile number is required");
            return;
        }

        const data = {
            yinId: this.state.member?.yin_id,
            rewardType: this.state.selectedBenefits.map(item => item.toLowerCase()),
        };

        try {
            this.setState({ isloader: true });

            const response = await axios.post(
                process.env.REACT_APP_APIURL + `/qrsub/scanQRCode`,
                data,
                {
                    validateStatus: (status) => {
                        return status === 200 || status === 606;
                    },
                }
            );

            if (response.status === 200) {
                alert("Reward submitted successfully!");
                window.location.href = '/list/scanner';
            } else if (response.status === 606) {
                alert(response.data.message);
            } else {
                alert(response.Message);
            }

        } catch (error) {
            console.error("Error while submitting reward:", error);
            alert("Failed to submit reward");
        } finally {
            this.setState({ isloader: false, selectedBenefits: [] });
        }
    };

    handleBenefitChange = (e) => {
        let { selectedBenefits } = this.state;
        if (e.target.checked) {
            selectedBenefits.push(e.target.value);
        } else {
            selectedBenefits = selectedBenefits.filter(item => item !== e.target.value);
        }
        this.setState({ selectedBenefits });
    }

    render() {
        const { subscriptionData, member } = this.state;

        return (
            <>
                <Sidebar />
                <div className="main">
                    <div className="topbar">
                        <Navbar />
                    </div>

                    <div className="container">
                        <div className="row mt-4">
                            <div className="col-lg-8 col-md-8 col-12 paddingAll10 mx-auto ">
                                <div className="card rounded shadow shadow-sm">
                                    <div className="card-header">
                                        <h3 className="mb-0 center">Scan By Mobile Number</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="form-group">
                                            <label htmlFor="mobile" className="control-label">Mobile Number</label>
                                            <input
                                                type="text"
                                                name="mobile"
                                                value={this.state.mobile}
                                                onChange={this.handleFormChange}
                                                className="form-control"
                                                placeholder="Type here"
                                                maxLength={10}
                                                pattern="\d*"
                                            />
                                            <div className="errorMsg">{this.state.errors.mobile}</div>
                                        </div>

                                        {/* First Submit Button */}
                                        {!member && (
                                            <div className="form-group">
                                                <button
                                                    onClick={() => this.getMemberListbyMobileNumber(this.state.mobile)}
                                                    className="btn btn-primary btn-lg btn-block"
                                                    style={{ marginLeft: "300px" }}
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                        )}

                                        <br />
                                        {member && (
                                            <div>
                                                <div className="row mt-2">
                                                    <div className="col">
                                                        <div className="card rounded shadow shadow-sm">
                                                            <div className="card">
                                                                <h3 className="card-title mb-0 text-center"><b>Profile</b></h3>
                                                                <div className="row align-items-center" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                                    <div className="img col d-flex justify-content-center">
                                                                        {member.profile_image[0] ? (
                                                                            <img src={member.profile_image[0]} alt="imhe" width="250px" height="140px" />
                                                                        ) : (
                                                                            <img src={logo} alt="image_logo" />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <br />
                                                                <div className="card-header1  text-center">
                                                                    <div>
                                                                        <label><h5><b>{member.first_name}&nbsp;{member.last_name}</b></h5></label><br />
                                                                        <label>College Name: {member.college_name}</label><br />
                                                                        <label>Mobile: {member.mobile}</label><br />
                                                                        <label>YIN ID: {member.yin_id}</label><br />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br />

                                                {/* Second Submit Button -> Modal open */}
                                                <div className="form-group text-center mt-4">
                                                    {subscriptionData?.claimedRewards &&
                                                        Object.values(subscriptionData.claimedRewards).every(val => val === true) ? (
                                                        <div className="alert alert-success fw-bold" role="alert" style={{ fontSize: "18px" }}>
                                                            🎉 You have received all your goodies!
                                                        </div>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-lg"
                                                            onClick={() => {
                                                                if (!this.state.mobile) {
                                                                    alert("Mobile number is required");
                                                                    return;
                                                                }
                                                                this.setState({ showPopup: true });
                                                            }}
                                                        >
                                                            {this.state.isloader ? <LoaderRounded /> : "Submit"}
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Popup Modal */}
                <Modal show={this.state.showPopup} onHide={() => this.setState({ showPopup: false })} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Please select membership benefits</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            {/* Bag */}
                            <div className="col d-flex align-items-center">
                                {subscriptionData?.claimedRewards?.bag ? (
                                    <span style={{ color: "green", fontWeight: "600" }}>
                                        ✅ Bag
                                    </span>
                                ) : (
                                    <>
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-2"
                                            value="Bag"
                                            id="bagCheck"
                                            onChange={this.handleBenefitChange}
                                            style={{ border: "1px solid #000", width: "18px", height: "18px" }}
                                        />
                                        <label className="form-check-label mt-2" htmlFor="bagCheck">
                                            Bag
                                        </label>
                                    </>
                                )}
                            </div>

                            {/* Bottle */}
                            <div className="col d-flex align-items-center">
                                {subscriptionData?.claimedRewards?.bottle ? (
                                    <span style={{ color: "green", fontWeight: "600" }}>
                                        ✅ Bottle
                                    </span>
                                ) : (
                                    <>
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-2"
                                            value="Bottle"
                                            id="bottleCheck"
                                            onChange={this.handleBenefitChange}
                                            style={{ border: "1px solid #000", width: "18px", height: "18px" }}
                                        />
                                        <label className="form-check-label mt-2" htmlFor="bottleCheck">
                                            Bottle
                                        </label>
                                    </>
                                )}
                            </div>

                            {/* Kit */}
                            <div className="col d-flex align-items-center">
                                {subscriptionData?.claimedRewards?.kit ? (
                                    <span style={{ color: "green", fontWeight: "600" }}>
                                        ✅ Kit
                                    </span>
                                ) : (
                                    <>
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-2"
                                            value="Kit"
                                            id="kitCheck"
                                            onChange={this.handleBenefitChange}
                                            style={{ border: "1px solid #000", width: "18px", height: "18px" }}
                                        />
                                        <label className="form-check-label mt-2" htmlFor="kitCheck">
                                            Kit
                                        </label>
                                    </>
                                )}
                            </div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => this.setState({ showPopup: false })}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            disabled={this.state.selectedBenefits.length === 0}
                            onClick={() => {
                                if (!this.state.mobile) {
                                    alert("Mobile number is required");
                                    return;
                                }
                                this.setState({ showPopup: false }, () => {
                                    this.submitRewards();
                                });
                            }}
                        >
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}







